import { render, staticRenderFns } from "./ActualizarSolicitud.vue?vue&type=template&id=6c2c8854"
import script from "./ActualizarSolicitud.vue?vue&type=script&lang=js"
export * from "./ActualizarSolicitud.vue?vue&type=script&lang=js"
import style0 from "./ActualizarSolicitud.vue?vue&type=style&index=0&id=6c2c8854&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports